import { useRef } from "react";
import { HeaderButton } from "@src/components/Header/HeaderButton";
import { LoginForm } from "@src/components/Forms/User/loginUser/LoginForm";
import { useModal } from "@src/utility_functions/customHooks/useModal";

export const HeaderButtonsNotLoggedIn = (props) => {
  const { openDialog, setModalContent } = useModal();
  const buttonRef = useRef<HTMLButtonElement>(null!);

  return (
    <div className="_position--relative">
      <div className="header_button_container _display--inline-block">
        <HeaderButton
          className="header_button_text"
          icon="Log In"
          handleClick={() => {
            openDialog();
            setModalContent({
              modalTitle: "Log In",
              dialogWidth: "50%",
              modalContent: (
                <div>
                  <LoginForm loggedInUser={props.loggedInUser} />
                </div>
              ),
            });
          }}
          buttonRef={buttonRef}
          dropdownOpen={false}
        />
      </div>
    </div>
  );
};
